import React, { useEffect, useState } from "react";
import moment from "moment";
import "moment/locale/ru";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Aviation } from "../../../../../../../services";
import CustomButton from "../../../../../../custom/custom-button/CustomButton";
import CustomDatePicker from "../../../../../../shared/date-picker/Date";
import CalendarIcon from "../../../../../../shared/icons/CalendarIcon";
import ExpectedArrivalCalendar from "../../../../../../orders-new/order-info-expeditor/components/ExpectedArrivalBlock/ExpectedArrivalCalendar";
import style from "../../../../../../orders-new/order-info-expeditor/components/ExpectedArrivalBlock/ExpectedArrivalBlock.module.scss";

const ExpeditorExpectedArrivalBlock = ({ order, fetchOrderData }) => {
  const { t } = useTranslation();
  const initialUnloadingDate = order?.expectedUnloadingDate || null;
  const [date, setDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setDate(initialUnloadingDate ? new Date(initialUnloadingDate) : null);
  }, [initialUnloadingDate, order?.id]);

  if (String(order?.status || "").toLowerCase() !== "onthetrip") return null;

  const handleAdd = async () => {
    if (!date || !order?.id) {
      toast.error(t("orderFilter.datePlaceholder"));
      return;
    }

    setIsLoading(true);
    try {
      await Aviation.updateExpectedUnloadingDate(order.id, {
        expectedUnloadingDate: date.toISOString(),
      });
      toast.success(t("orderInfoExpeditor.expectedArrival.dateUpdated"));
      await fetchOrderData?.();
    } catch (error) {
      console.error(error);
      toast.error(t("orderInfoExpeditor.expectedArrival.updateDateError"));
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setDate(initialUnloadingDate ? new Date(initialUnloadingDate) : null);
  };

  if (initialUnloadingDate) {
    return (
      <div className={style.card}>
        <div className={style.topbar}>
          <span className={style.topbar_title}>
            {t("orderInfoExpeditor.expectedArrival.title")}
          </span>
        </div>

        <div className={style.view_row}>
          <div className={style.view_date}>
            <CalendarIcon />
            <span>{moment(initialUnloadingDate).locale("ru").format("D MMMM YYYY")}</span>
          </div>
          <ExpectedArrivalCalendar
            selected={date}
            onChange={setDate}
            onClear={() => setDate(null)}
            onSelect={handleAdd}
            isLoading={isLoading}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={style.card}>
      <div className={style.topbar}>
        <span className={style.topbar_title}>
          {t("orderInfoExpeditor.expectedArrival.title")}
        </span>
      </div>

      <div className={style.date_field}>
        <span className={style.date_label}>{t("orderFilter.datePlaceholder")}</span>
        <CustomDatePicker
          selected={date}
          placeholderText={t("orderFilter.datePlaceholder")}
          dateFormat="dd.MM.yyyy"
          onChange={setDate}
          popperProps={{ strategy: "fixed" }}
        />
        <CalendarIcon />
      </div>

      <div className={style.buttons_row}>
        <div className={style.btn_primary}>
          <CustomButton
            text={t("orderInfoExpeditor.expectedArrival.add")}
            isNavy
            onClick={handleAdd}
            isLoading={isLoading}
            disabled={isLoading}
            style={{ width: "100%" }}
          />
        </div>
        <div className={style.btn_secondary}>
          <CustomButton
            text={t("common.cancel")}
            isNavy
            isWhite
            onClick={handleCancel}
            disabled={isLoading}
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
};

export default ExpeditorExpectedArrivalBlock;

